import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../../../MsalAuthConfig";

const MsalAuthLogin = () => {
  const { instance, inProgress } = useMsal();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  useEffect(() => {
    const login = async() => {
      if (inProgress === "none" && !instance.getAllAccounts().length) {
        try {
          await instance.loginRedirect(loginRequest);
        } catch (error) {
          console.error("Login failed:", error);
        } finally {
          setLoading(false);
        }
      } else {
        if (instance.getAllAccounts().length) {
          navigate("/create-project");
        }
        setLoading(false);
      }
    };

    login();
  }, [instance, inProgress, navigate]);


  
  return (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justifyContent='center'
      sx={{ minHeight: "100vh" }}
    >
      {loading ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress color='error' />
        </Box>
      ):null}
    </Grid>
  );
};

export default MsalAuthLogin;
